import React from 'react';

function WitnessCapture({ witnesses, setWitnesses }) {
  function addWitness() {
    setWitnesses([...witnesses, { name: '', role: '', statement: '', contact: '' }]);
  }

  function removeWitness(index) {
    setWitnesses(witnesses.filter((_, i) => i !== index));
  }

  function updateWitness(index, field, value) {
    const updated = witnesses.map((w, i) =>
      i === index ? { ...w, [field]: value } : w
    );
    setWitnesses(updated);
  }

  return (
    <div className="ff-card" data-testid="witness-capture">
      <div className="ff-section-header">
        <div>
          <h2>Witnesses</h2>
          <p className="ff-card-description">
            Add anyone who was present or may have seen or heard what happened.
          </p>
        </div>
        <button
          type="button"
          className="ff-btn-outline ff-add-btn"
          onClick={addWitness}
          data-testid="add-witness-btn"
        >
          + Add Witness
        </button>
      </div>

      {witnesses.length === 0 && (
        <p className="ff-empty-state">No witnesses added yet.</p>
      )}

      <div className="ff-witness-list">
        {witnesses.map((witness, index) => (
          <div key={index} className="ff-witness-item" data-testid={`witness-${index}`}>
            <div className="ff-witness-row">
              <div className="ff-field">
                <label className="ff-label">Name</label>
                <input
                  type="text"
                  className="ff-input"
                  value={witness.name}
                  onChange={(e) => updateWitness(index, 'name', e.target.value)}
                  placeholder="Full name"
                  data-testid={`witness-name-${index}`}
                />
              </div>
              <div className="ff-field">
                <label className="ff-label">Role</label>
                <input
                  type="text"
                  className="ff-input"
                  value={witness.role}
                  onChange={(e) => updateWitness(index, 'role', e.target.value)}
                  placeholder="Coworker, supervisor, etc."
                  data-testid={`witness-role-${index}`}
                />
              </div>
              <div className="ff-field">
                <label className="ff-label">Contact (optional)</label>
                <input
                  type="text"
                  className="ff-input"
                  value={witness.contact}
                  onChange={(e) => updateWitness(index, 'contact', e.target.value)}
                  placeholder="Phone or email"
                  data-testid={`witness-contact-${index}`}
                />
              </div>
              <button
                type="button"
                className="ff-remove-btn"
                onClick={() => removeWitness(index)}
                data-testid={`remove-witness-${index}`}
                title="Remove witness"
              >
                &times;
              </button>
            </div>
            <div className="ff-field ff-full-width">
              <label className="ff-label">What did they see or hear?</label>
              <textarea
                className="ff-textarea ff-textarea-small"
                value={witness.statement}
                onChange={(e) => updateWitness(index, 'statement', e.target.value)}
                placeholder="Describe what this person observed..."
                rows={3}
                data-testid={`witness-statement-${index}`}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WitnessCapture;
